<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.12</b> - Улучшения Caverns и исправления ошибок</p>
    <div class="ml-5 pb-4 text-green-400">
      <div class="font-bold mt-2">Геймплей и балансировка</div>
      <ul class="ml-4 list-disc">
        <li>Ослаблены Летающие медузы</li>
        <li>
          Игроки, которые поддерживают максимальный ранг (10) в Таверна Tournaments, теперь получают
          награды за улучшение
        </li>
        <li>
          Комнаты Пещеры теперь генерируются как минимум с 20 дополнительными клетками сверх
          количества юнитов игроков
        </li>
      </ul>

      <div class="font-bold mt-2">ИИ</div>
      <ul class="ml-4 list-disc">
        <li>
          Улучшено принятие решений для способностей с областным эффектом, чтобы избежать нанесения
          урона союзникам
        </li>
      </ul>

      <div class="font-bold mt-2">Исправления ошибок</div>
      <ul class="ml-4 list-disc">
        <li>
          Исправлена ошибка, когда Журнал сражений Пещеры не обрабатывал события при скрытой вкладке
          браузера
        </li>
        <li>Исправлено отображение таймера в подсказке зелья Опыт</li>
        <li>Исправлены проблемы с прокруткой в окнах Журнала сражений и Журналов таверны</li>
      </ul>

      <div class="font-bold mt-2">Улучшения качества жизни</div>
      <ul class="ml-4 list-disc">
        <li>Журналы сражений таверны теперь показывают, были ли сражения атаками или защитами</li>
        <li>
          Подсказки активных зелий Опыт теперь показывают оставшееся время вместо общей
          продолжительности
        </li>
        <li>Журнал сражений Пещеры теперь останавливается, когда группа побеждена</li>
      </ul>
    </div>
  </div>
</template>
